import classNames from "classnames";

type Props = React.HTMLAttributes<HTMLDivElement>;

export default function LoadingDots({ className, ...props }: Props) {
  return (
    <div
      className={classNames(
        "ms-2 flex gap-1 self-center text-center align-middle leading-none transition-colors duration-150",
        className,
      )}
      {...props}
    >
      <span
        className="bg-primary-500 inline-block h-1 w-1 rounded-full align-top"
        style={{ animation: "dot-animation 1s ease-in-out 0ms infinite" }}
      />
      <span
        className="bg-primary-500 inline-block h-1 w-1 rounded-full align-top"
        style={{ animation: "dot-animation 1s ease-in-out 160ms infinite" }}
      />
      <span
        className="bg-primary-500 inline-block h-1 w-1 rounded-full align-top"
        style={{ animation: "dot-animation 1s ease-in-out 320ms infinite" }}
      />
    </div>
  );
}
